// extracted by mini-css-extract-plugin
module.exports = {"platformPageWrap":"Platform_platformPageWrap__JF4sw","mainMetricsSection":"Platform_mainMetricsSection__2oTLC"};